/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Email notification preferences
 * @export
 * @interface NotificationSettingsSettingsEmail
 */
export interface NotificationSettingsSettingsEmail {
    /**
     * 
     * @type {boolean}
     * @memberof NotificationSettingsSettingsEmail
     */
    claim?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof NotificationSettingsSettingsEmail
     */
    document?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof NotificationSettingsSettingsEmail
     */
    comparison?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof NotificationSettingsSettingsEmail
     */
    task?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof NotificationSettingsSettingsEmail
     */
    supplement?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof NotificationSettingsSettingsEmail
     */
    note?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof NotificationSettingsSettingsEmail
     */
    email?: boolean;
}

/**
 * Check if a given object implements the NotificationSettingsSettingsEmail interface.
 */
export function instanceOfNotificationSettingsSettingsEmail(value: object): value is NotificationSettingsSettingsEmail {
    return true;
}

export function NotificationSettingsSettingsEmailFromJSON(json: any): NotificationSettingsSettingsEmail {
    return NotificationSettingsSettingsEmailFromJSONTyped(json, false);
}

export function NotificationSettingsSettingsEmailFromJSONTyped(json: any, ignoreDiscriminator: boolean): NotificationSettingsSettingsEmail {
    if (json == null) {
        return json;
    }
    return {
        
        'claim': json['claim'] == null ? undefined : json['claim'],
        'document': json['document'] == null ? undefined : json['document'],
        'comparison': json['comparison'] == null ? undefined : json['comparison'],
        'task': json['task'] == null ? undefined : json['task'],
        'supplement': json['supplement'] == null ? undefined : json['supplement'],
        'note': json['note'] == null ? undefined : json['note'],
        'email': json['email'] == null ? undefined : json['email'],
    };
}

export function NotificationSettingsSettingsEmailToJSON(json: any): NotificationSettingsSettingsEmail {
    return NotificationSettingsSettingsEmailToJSONTyped(json, false);
}

export function NotificationSettingsSettingsEmailToJSONTyped(value?: NotificationSettingsSettingsEmail | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'claim': value['claim'],
        'document': value['document'],
        'comparison': value['comparison'],
        'task': value['task'],
        'supplement': value['supplement'],
        'note': value['note'],
        'email': value['email'],
    };
}

